// @flow

import { getItem } from './storage'

const CHATCHAMP_COLOR = 'color:grey'

export const LOGGING_COOKIE_NAME = 'trbo_ac-logging'

function messageColor (): string {
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) return 'color:white'
  return 'color:black'
}

function loggingEnabled () {
  return (process.env.NODE_ENV === 'development') ||
    ((process.env.NODE_ENV === 'production') && Boolean(getItem(LOGGING_COOKIE_NAME)))
}

const log = (message: string, level: string) => {
  if (!loggingEnabled()) return

  if (level === 'info') {
    const time = Math.round(performance.now())
    // eslint-disable-next-line no-console
    console.log(`%c${time} %cchatchamp: %c${message}`, CHATCHAMP_COLOR, CHATCHAMP_COLOR, messageColor())
  } else if (level === 'warning') {
    console.warn(message) // eslint-disable-line no-console
  } else if (level === 'error') {
    // eslint-disable-next-line no-console
    console.error(`%cchatchamp: %c${message}`, CHATCHAMP_COLOR, 'color:red')
  }
}

const logInfo = (message: string): any => {
  return log(message, 'info')
}

const logWarning = (message: string): any => {
  return log(message, 'warning')
}

const logError = (message: string): any => {
  return log(message, 'error')
}

export const logger = {
  info: logInfo,
  warn: logWarning,
  error: logError
}
